import type { CustomIconComponentProps } from './_type';

import { memo } from 'react';

import Icon from '@ant-design/icons';

import { AddTextSvg } from './_svg';

export default memo((props: Partial<CustomIconComponentProps>) => {
  return (
    <Icon
      component={AddTextSvg}
      {...props}
    />
  );
});
